<template>
  <div
    class="game-card"
    :class="{ 'active': active }"
    @click="onCardClick"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div v-if="game.brand_game_category_id.includes('HOT')" class="game-info-icon-hot">
      HOT
    </div>
    <div v-if="game.brand_game_category_id.includes('NEW')" class="game-info-icon-new">
      NEW
    </div>
    <div class="game-card-name">
      <div class="game-tx">
        <div class="game-name name-tex">
          {{ game.name }}
        </div>
        <div class="game-provider">
          <img :src="providerImage" alt="">
        </div>
      </div>
      <div class="game-info">
        <i class="game-info-icon" />
        <i
          v-if="token"
          class="game-info-icon-heart-show"
          :class="{ active: game.isFavorite }"
          @click.stop="$emit('favorite', game)"
        />
        <i
          v-if="isNoBonusGame(game)"
          class="game-info-icon-nobonus-show"
        />
      </div>
    </div>
    <div class="game-card-image">
      <div class="img-mask" :class="{ 'D-none': isTheme('theme_neotri') }" />
      <d-img :src="game" :alt="game.name" />
    </div>

    <div class="game-card-info">
      <div class="game-info-bn">
        <button @click.stop="$emit('launch', game)">
          {{ $t("Bao.play_game_now") }}
        </button>
        <button v-if="game.demo_url" @click.stop="$emit('demo', game)">
          {{ $t('Bao.demo') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import dImg from '@/components/dynamicImg'
import { detectMob } from '@/utils/tool'
import themeMixin from '@/mixins/themeMixin'

export default {
  name: 'GameCard',
  components: {
    dImg
  },
  mixins: [themeMixin],
  props: {
    game: {
      type: Object,
      required: true
    },
    // 是否已登入，控制愛心與點擊行為
    token: {
      type: [String, Boolean],
      default: false
    },
    // 是否為目前 hover 的卡片
    active: {
      type: Boolean,
      default: false
    },
    // 供應商圖片（由父層解析後傳入）
    providerImage: {
      type: String,
      default: ''
    }
  },
  methods: {
    // 遊戲的 support_wallet_type 沒有支援 bonus 錢包時，顯示禁止贈金的小圖示
    isNoBonusGame(game) {
      return Array.isArray(game.support_wallet_type) && !game.support_wallet_type.includes('bonus')
    },
    onCardClick() {
      if (this.token) {
        this.$emit('launch', this.game)
      } else {
        this.$emit('hover', this.game.id)
      }
    },
    onMouseEnter() {
      if (!detectMob() && !this.token) {
        this.$emit('hover', this.game.id)
      }
    },
    onMouseLeave() {
      if (!detectMob() && !this.token) {
        this.$emit('hover', null)
      }
    }
  }
}
</script>
